import queryString from 'query-string';
import { Component, Mixins } from 'vue-property-decorator';
import PrivilegeMixin from './PrivilegeMixin';
import RoundButton from '@/components/RoundButton.vue';
import RoundButtonMenu from '@/components/RoundButtonMenu.vue';
import DetailField from '@/components/DetailField.vue';
import formatting from '@/formatting';
import { api } from '../api';
import { DetailLayoutITF, ReportFileTableITF } from '@/interfaces';

@Component({
  components: { RoundButton, RoundButtonMenu, DetailField }
})
export default class CommonMixin extends Mixins(PrivilegeMixin) {
  public api = api;
  public queryString = queryString;
  public formatting = formatting;

  public async save(rec, apiUrl, endpoint = 'file') {
    const ref: any = this.$refs.layout;
    if (ref.isNew) {
      const response = await this.api.createRecord(this.$store, apiUrl, rec);
      if (response) {
        ref.rec = response.data;
        await this.uploadFiles(ref.rec.id, apiUrl, endpoint);
        this.updateRecord(ref, ref.rec.id, apiUrl);
        this.$router.push(ref.url + '/' + ref.rec.id);
      }
    } else {
      const response = await this.api.updateRecord(
        this.$store,
        apiUrl + rec.id,
        rec
      );
      await this.uploadFiles(rec.id, apiUrl, endpoint);
      this.updateRecord(ref, rec.id, apiUrl);
      this.$router.push(ref.url + '/' + rec.id);
    }
  }

  public async saveWithFiles(apiUrl) {
    const ref: any = this.$refs.layout;
    if (ref.isNew) {
      const response = await this.api.createRecord(
        this.$store,
        apiUrl,
        ref.rec
      );
      if (response) {
        ref.rec = response.data;
        const filesRef: any = this.$refs.files;
        await (filesRef as ReportFileTableITF).saveAllFiles(ref.rec.id);
        this.$router.push(ref.url + '/' + ref.rec.id);
      }
    } else {
      (ref as DetailLayoutITF).commitRecord(ref.rec);
    }
  }

  public async updateRecord(ref, id, apiUrl) {
    const recordResponse = await this.api.getRecord(this.$store, apiUrl + id);
    if (recordResponse) {
      ref.rec = recordResponse.data;
      ref.theForm.resetValidation();
    }
    ref.loading = false;
  }

  public async uploadFiles(id, apiUrl, endpoint) {
    const ref: any = this.$refs.upload;
    ref.errorMessages = '';
    const formData = new FormData();
    if (Array.isArray(ref.files) && ref.files.length > 0) {
      // Multiple files
      for (const x of Object.keys(ref.files)) {
        const file: Blob = ref.files[x];
        formData.append('file', file);
      }
    } else if (!Array.isArray(ref.files) && ref.files) {
      // Single file
      formData.append('file', ref.files);
    } else {
      // Do nothing
      return;
    }
    const response = await this.api.uploadFile(
      this.$store,
      apiUrl + id + '/' + endpoint,
      formData
    );
    ref.files = [];
  }

  public openGoogleMapsRoute(coordSrc, coordDst) {
    if (coordSrc && coordDst) {
      let link = 'https://www.google.com/maps/dir/?api=1';
      link += '&origin=' + coordSrc.lat + ',' + coordSrc.lon;
      link += '&destination=' + coordDst.lat + ',' + coordDst.lon;
      window.open(link, '_blank');
    }
  }

  public openLink(endpoint, id) {
    if (id) {
      const routeData = this.$router.resolve({
        path: endpoint + String(id)
      });
      window.open(routeData.href, '_blank');
    }
  }

  public openNewView(url, queryObj) {
    if (queryObj) {
      const path = url + '/new?' + queryString.stringify(queryObj);
      this.$router.push(path);
    }
  }

  public async duplicateRecord(apiUrl, clientURL, queryObj, newProps = {}) {
    const response = await api.duplicateRecord(
      this.$store,
      apiUrl,
      queryObj,
      newProps
    );
    if (response) {
      this.$router.push(clientURL + '/' + response.data.id + '?mode=edit');
    }
  }

  public getTableCfg(tableCfg, key, context = this) {
    if (typeof tableCfg[key] === 'function') {
      return tableCfg[key](context);
    } else {
      return tableCfg[key];
    }
  }

  public otpStatusText = function otpStatusText(value) {
    if (value === 'Off') {
      return 'Uit';
    } else if (value === 'WaitForSetup') {
      return 'Klaar voor instellen';
    } else if (value === 'On') {
      return 'Aan';
    } else if (value === 'Expired') {
      return 'Verlopen';
    } else {
      return '';
    }
  };

  public otpStatusColor = function otpStatusColor(value) {
    if (value === 'Off') {
      return 'grey lighten-2';
    } else if (value === 'WaitForSetup') {
      return 'primary';
    } else if (value === 'On') {
      return 'success';
    } else if (value === 'Expired') {
      return 'error';
    } else {
      return 'grey lighten-2';
    }
  };

  public async exportFields(apiUrl, id) {
    this.api.downloadAction(this.$store, apiUrl + String(id) + '/jsonfile');
  }
}
